export enum CookieName {
  TOKEN = 'token'
};

export enum Aria {
  HIDDEN = 'aria-hidden',
  TRUE = 'true'
}

export enum SortOption {
  NAME = 'name',
  DISTANCE = 'distance'
}

export enum ClassState {
  IS_FIXED = 'isFixed'
}
